module.exports = __webpack_public_path__ + "static/media/offertericondizionati.02536d04.png";